import { Trash2, Loader2, Sparkles, Play, Square } from "lucide-react";
import { fmt } from "@/lib/studioUtils";
import { PanelSection } from "./PanelSection";

const actionBtn = "flex items-center gap-1 text-xs font-medium text-zinc-500 hover:text-rose-600 disabled:opacity-30 disabled:hover:text-zinc-500 transition-colors";

function CommentRow({ c, improving, speaking, disabled, onChange, onDelete, onSeek, preview, onPreview, onRepolish }) {
  const off = disabled || improving;
  return (
    <li data-testid={`comment-row-${c.id}`}
      className={`border rounded-[4px] p-3 transition-colors ${speaking ? "border-yellow-400 bg-yellow-50" : "border-zinc-200"}`}>
      <div className="flex items-center justify-between gap-3 mb-2">
        <button type="button" onClick={() => onSeek(c.t)} disabled={disabled} data-testid={`comment-time-${c.id}`} title="Jump to this moment"
          className="font-mono text-xs text-rose-600 hover:text-rose-700">{fmt(Math.floor(c.t))}</button>
        <div className="flex items-center gap-4">
          <button type="button" onClick={onRepolish} disabled={off || !c.text.trim()} data-testid={`comment-repolish-${c.id}`} className={actionBtn}>
            <Sparkles size={13} /> Re-polish
          </button>
          <button type="button" onClick={onPreview} disabled={off || !c.text.trim()} data-testid={`comment-preview-${c.id}`} className={actionBtn}>
            {preview === "loading" ? <Loader2 size={13} className="animate-spin" /> : preview === "playing" ? <Square size={11} fill="currentColor" /> : <Play size={12} fill="currentColor" />}
            {preview === "playing" ? "Stop" : "Play"}
          </button>
          <button type="button" onClick={onDelete} disabled={off} data-testid={`comment-delete-${c.id}`} className={actionBtn}>
            <Trash2 size={13} /> Delete
          </button>
        </div>
      </div>
      {improving ? (
        <div className="flex items-center gap-2 text-sm text-zinc-500 py-1" data-testid={`comment-improving-${c.id}`}>
          <Loader2 size={14} className="animate-spin" /> Polishing with AI…
        </div>
      ) : (
        <textarea value={c.text} onChange={(e) => onChange(e.target.value)} rows={2} maxLength={500} disabled={disabled}
          data-testid={`comment-text-${c.id}`}
          className="w-full bg-white border border-zinc-200 hover:border-zinc-300 rounded-[4px] px-3 py-1.5 text-sm text-zinc-900 outline-none focus:border-rose-500 transition-colors resize-y" />
      )}
    </li>
  );
}

// Saved comments, in timestamp order.
export function CommentsPanel({ comments, onChange, onDelete, onSeek, improvingIds, speakingId, disabled, preview, onPreview, onRepolish }) {
  return (
    <div className="mt-6" data-testid="comments-panel">
      <PanelSection label={`Comments${comments.length ? ` (${comments.length})` : ""}`} testId="comments-section">
        {comments.length === 0 ? (
          <p className="text-xs text-zinc-400" data-testid="comments-empty">No comments yet. Press Enter Comment at any moment of the video.</p>
        ) : (
          <ul className="flex flex-col gap-2" data-testid="comments-list">
            {comments.map((c) => (
              <CommentRow key={c.id} c={c} improving={improvingIds.has(c.id)} speaking={speakingId === c.id} disabled={disabled}
                onChange={(text) => onChange(c.id, text)} onDelete={() => onDelete(c.id)} onSeek={onSeek}
                preview={preview?.id === c.id ? preview.state : null} onPreview={() => onPreview(c)} onRepolish={() => onRepolish(c.id)} />
            ))}
          </ul>
        )}
      </PanelSection>
    </div>
  );
}
